module.exports = __webpack_public_path__ + "media/images/games/dota-2/square-fc623a91686763a012f9a9acc4fedbf5.jpg";